import React, { useEffect, useState, useContext } from "react";
import "./MyProject.scss";
import { userContext } from "../../context/Auth";
import axios from "axios";
import moment from "moment";
import image1 from "../../components/picture/img1.jpg";
import image2 from "../../components/picture/img2.jpg";
import image3 from "../../components/picture/img3.jpg";
import image4 from "../../components/picture/img4.jpg";
import image5 from "../../components/picture/img5.jpg";
import image6 from "../../components/picture/img6.jpg";

const MyProject = () => {
  // const [profile, setProfile] = useState(null);
  // const { user } = useContext(userContext);

  // useEffect(() => {
  //   const profileFetch = async () => {
  //     if (!user || !user.data) {
  //       console.error("User data is not available");
  //       return;
  //     }

  //     try {
  //       const response = await axios.get(
  //         "https://api.springwayhub.com/mlm/check/status",
  //         {
  //           headers: {
  //             user_id: user.data.user_id,
  //             api_key: user.data.user_api_key,
  //           },
  //         }
  //       );
  //       setProfile(response.data.data);
  //     } catch (error) {
  //       console.log(error);
  //     }
  //   };

  //   profileFetch();
  // }, [user]);

  const images = [image1, image2, image3, image4, image5, image6];
  const [selectedImage, setSelectedImage] = useState(null);
  // if (!profile) {
  return (
    <div className="no-project">
      <div className="gallery-container">
        <div className="gallery-grid">
          {images.map((src, index) => (
            <img
              key={index}
              src={src}
              alt={`Gallery ${index}`}
              className="gallery-item"
              onClick={() => setSelectedImage(src)}
            />
          ))}
        </div>
        {selectedImage && (
          <div
            className="gallery-modal"
            onClick={() => setSelectedImage(null)}
          >
            <img
              src={selectedImage}
              alt="Selected"
              className="gallery-modal-img"
            />
          </div>
        )}
      </div>
    </div>
  ); // Add a loading state while the profile is being fetched
  // }

  // const newDate = profile.dob ? moment(profile.dob).format("DD-MM-YYYY") : "";
  // return (
  //   <div className="container-fluid profile-id">
  //     <h1>ID CARD</h1>
  //     <div className="id-card">
  //       <div className="id-border">
  //         <div className="logo">
  //           <img src="./images/main_logo.png" alt="logo" id="idLogo" />
  //           <h5>Springway</h5>
  //         </div>

  //         <div className="profile-image">
  //           <img
  //             src={`https://api.springwayhub.com/${profile.image}`}
  //             alt="Profile"
  //           />
  //         </div>
  //         <div className="profile-details">
  //           <h6>
  //             Name: <span>{profile.account_name || ""}</span>
  //           </h6>
  //           <h6>
  //             Referral-ID: <span>{profile.u_referal_id || ""}</span>
  //           </h6>
  //           <h6>
  //             Date of Birth: <span>{newDate || ""}</span>
  //           </h6>
  //           <h6>
  //             Address: <span>{profile.address || ""}</span>
  //           </h6>
  //         </div>
  //       </div>
  //     </div>
  //     <button>Download Pdf</button>
  //   </div>
  // );
};

export default MyProject;
